export default class LimitedTimeOfferCard extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div>
                <a href={this.props.pageUrl}>
                <div className="limited-time-menu-cards-container">
                    <div className="row">

                    <div className="col-6 align-title">
                        <div className="limited-time-menus-title">
                            <span>{this.props.cardTitle}</span>
                            <span>{this.props.productName}</span>
                        </div>
                    </div>
                    <div className="col-6 gutter-free">
                        <row>
                            <div className="col limited-time-menus-img-container">
                                <div role="img" aria-label="limited-time-menu-item">
                                    <img className="limited-time-menus-img"
                                         src={this.props.imageUrl}
                                         alt="limited time offer menu Image" />
                                </div>
                            </div>

                            <div className="col">
                                <div role="img" className="limited-time-menus-fire-logo-image" aria-label="limited-time-menus-fire-logo-image"></div>
                            </div>
                        </row>
                    </div>

                    </div>
                </div>
              </a>
            </div>
        );
    }
}
